// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"jgp-2p9CZ"};